"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiRadio = void 0;
exports.MuiRadio = {
    defaultProps: {
        color: 'primary',
    },
    styleOverrides: {
        colorPrimary: {
            color: '#0066ED',
            '&.Mui-checked': {
                color: '#0066ED',
            },
        },
    },
};
//# sourceMappingURL=MuiRadio.js.map